import React, { useState, useEffect } from 'react';
import AddSucursal from './AddSucursal'; // Asegúrate de tener este componente correctamente importado
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from '@mui/material';
import { ArrowUpward, ArrowDownward } from '@mui/icons-material';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';

function GestionSucursales() {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [sucursales, setSucursales] = useState([]);
    const [editSucursal, setEditSucursal] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [sucursalToDelete, setSucursalToDelete] = useState(null);
    const { user } = useUser();

    useEffect(() => {
        fetchSucursales();
    }, []);

    const fetchSucursales = async () => {
        try {
            const response = await fetch(`${server}/MgSucursales`);
            const data = await response.json();
            // Inicializar orden si no existe
            const sucursalesConOrden = data.$values.map((sucursal, index) => ({
                ...sucursal,
                orden: sucursal.orden != null ? sucursal.orden : index
            }));
            setSucursales(sucursalesConOrden);
        } catch (error) {
            console.error('Error al cargar las sucursales:', error);
        }
    };

    const handleNewSucursal = () => {
        fetchSucursales();
        setEditSucursal(null); // Reset the edit state after adding a new sucursal
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleOpenDialog = (sucursal) => {
        setSucursalToDelete(sucursal);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setSucursalToDelete(null);
    };

    const handleDeleteSucursal = async () => {
        if (sucursalToDelete) {
            try {
                const username = ''+user.codigoUsuario+'/';
                console.log(sucursalToDelete);
                const response = await fetch(`${server}/MgSucursales/${sucursalToDelete.idSucursal}/${username}`, {
                    method: 'DELETE'
                });
                if (response.ok) {
                    handleCloseDialog();
                    fetchSucursales(); // Refresh the list
                    alert('Sucursal eliminada con éxito');
                } else {
                    alert('Error al eliminar la sucursal');
                }
            } catch (error) {
                console.error('Error al eliminar la sucursal:', error);
                alert('Error al eliminar la sucursal');
            }
        }
    };

    // Función para actualizar orden de sucursal
    const updateOrdenSucursal = async (idSucursal, nuevoOrden) => {
        try {
            const codigoUsuario = user?.codigoUsuario || 'ADMIN';
            const username = codigoUsuario.padEnd(20, ' ');
            const usernameEncoded = encodeURIComponent(username);
            const response = await fetch(`${server}/MgSucursales/${idSucursal}/orden/${nuevoOrden}/${usernameEncoded}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || 'Error al actualizar orden de la sucursal');
            }
        } catch (error) {
            console.error('Error al actualizar orden de la sucursal:', error);
            throw error;
        }
    };

    // Función para mover sucursal hacia arriba
    const handleMoveUpSucursal = async (index) => {
        if (index === 0) return;
        
        const startIndex = page * rowsPerPage;
        const actualIndex = startIndex + index;
        
        const sucursalActual = filteredSucursales[actualIndex];
        const sucursalAnterior = filteredSucursales[actualIndex - 1];
        
        // Asegurar que ambas sucursales tengan orden definido
        const ordenActual = sucursalActual.orden != null ? sucursalActual.orden : actualIndex;
        const ordenAnterior = sucursalAnterior.orden != null ? sucursalAnterior.orden : actualIndex - 1;
        
        try {
            // Intercambiar los órdenes en el backend
            await updateOrdenSucursal(sucursalActual.idSucursal, ordenAnterior);
            await updateOrdenSucursal(sucursalAnterior.idSucursal, ordenActual);
            
            // Recargar datos desde el backend para reflejar cambios
            await fetchSucursales();
        } catch (error) {
            alert('Error al actualizar el orden: ' + error.message);
            await fetchSucursales();
        }
    };

    // Función para mover sucursal hacia abajo
    const handleMoveDownSucursal = async (index) => {
        const startIndex = page * rowsPerPage;
        const actualIndex = startIndex + index;
        
        if (actualIndex === filteredSucursales.length - 1) return;
        
        const sucursalActual = filteredSucursales[actualIndex];
        const sucursalSiguiente = filteredSucursales[actualIndex + 1];
        
        // Asegurar que ambas sucursales tengan orden definido
        const ordenActual = sucursalActual.orden != null ? sucursalActual.orden : actualIndex;
        const ordenSiguiente = sucursalSiguiente.orden != null ? sucursalSiguiente.orden : actualIndex + 1;
        
        try {
            // Intercambiar los órdenes en el backend
            await updateOrdenSucursal(sucursalActual.idSucursal, ordenSiguiente);
            await updateOrdenSucursal(sucursalSiguiente.idSucursal, ordenActual);
            
            // Recargar datos desde el backend para reflejar cambios
            await fetchSucursales();
        } catch (error) {
            alert('Error al actualizar el orden: ' + error.message);
            await fetchSucursales();
        }
    };

    const filteredSucursales = sucursales.filter(sucursal => sucursal.nombreSucursal.toLowerCase().includes(searchQuery.toLowerCase()));
  return (
        <>
            <div className="right_col" role="main">
                <div className="x_content">

                    <br />

                    <AddSucursal handleNewSucursal={handleNewSucursal} editSucursal={editSucursal} />

                    <h2>Sucursales Existentes</h2>
                    {/* <div className="row"> */}
                        {/* <div className="col-md-9 col-sm-4 offset-md-2"> */}
                            <TextField
                                label="Buscar Sucursal"
                                variant="outlined"
                                fullWidth
                                value={searchQuery}
                                onChange={handleSearchChange}
                                style={{ marginBottom: 20 }}
                            />
                            <div className="table-responsive">
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                            <TableCell>Orden</TableCell>
                                            <TableCell>Acciones</TableCell>
                                                <TableCell>Empresa</TableCell>
                                                <TableCell>Sucursal</TableCell>
                                                <TableCell>Abreviatura</TableCell>
                                                <TableCell>Telefono</TableCell>
                                                <TableCell>Horario Atención</TableCell>
                                                <TableCell>Código</TableCell>
                                                <TableCell>Descripción</TableCell>
                                                
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {filteredSucursales.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((sucursal, index) => (
                                                <TableRow key={sucursal.idSucursal}>
                                                    <TableCell>
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => handleMoveUpSucursal(index)}
                                                            disabled={index === 0 || !tienePermiso('Editar Sucursal')}
                                                        >
                                                            <ArrowUpward />
                                                        </IconButton>
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => handleMoveDownSucursal(index)}
                                                            disabled={index === filteredSucursales.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).length - 1 || !tienePermiso('Editar Sucursal')}
                                                        >
                                                            <ArrowDownward />
                                                        </IconButton>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Button color="primary" onClick={() => setEditSucursal(sucursal)} disabled={!tienePermiso('Editar Sucursal')}>Editar</Button>
                                                        <Button color="secondary" onClick={() => { handleOpenDialog(sucursal) }} disabled={!tienePermiso('Eliminar Sucursal')}>Eliminar</Button>
                                                    </TableCell>
                                                    <TableCell>{sucursal.nombreEmpresa}</TableCell>
                                                    <TableCell>{sucursal.nombreSucursal}</TableCell>
                                                    <TableCell>{sucursal.abreviatura}</TableCell>
                                                    <TableCell>{sucursal.telefono}</TableCell>
                                                    <TableCell>{sucursal.horario}</TableCell>
                                                    <TableCell>{sucursal.codigo}</TableCell>
                                                    <TableCell>{sucursal.descripcionPagWeb}</TableCell>
                                                    
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={filteredSucursales.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </TableContainer>
                                <Dialog
                                    open={openDialog}
                                    onClose={handleCloseDialog}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                            ¿Estás seguro de que deseas eliminar esta sucursal?
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleCloseDialog} color="primary">
                                            Cancelar
                                        </Button>
                                        <Button onClick={handleDeleteSucursal} color="primary" autoFocus>
                                            Eliminar
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            </div>
                        {/* </div> */}
                    {/* </div> */}
                </div>
            </div>
        </>
    );
}

export default GestionSucursales;
